import React from 'react';
import { Navbar } from '../components/barber/Navbar';
import { Hero } from '../components/barber/Hero';
import { Services } from '../components/barber/Services';
import { Testimonials } from '../components/barber/Testimonials';
import { Difference } from '../components/barber/Difference';
import { LocationHours } from '../components/barber/LocationHours';
import { FinalCTA } from '../components/barber/FinalCTA';
import { BookingToast } from '../components/barber/BookingToast';
export function BarberLanding() {
  return <div className="w-full min-h-screen bg-[#0d0d0d]" data-id="element-293">
      <Navbar data-id="element-294" />
      <main data-id="element-295">
        <Hero data-id="element-296" />
        <Services data-id="element-297" />
        <Testimonials data-id="element-298" />
        <Difference data-id="element-299" />
        <LocationHours data-id="element-300" />
        <FinalCTA data-id="element-301" />
      </main>
      <BookingToast data-id="element-302" />
    </div>;
}